import React, { useState, useEffect } from "react";
import Select from "react-select";
import axios from "axios";
import html2pdf from "html2pdf.js";

// ✅ Duty translations for Urdu
const dutyMapUrdu = {
  M: "صبح",
  E: "دوپہر",
  N: "رات",
  "D/O": "چھٹی",
  L: "چھٹی",
  P: "حاضر",
  A: "غیر حاضر",
};

// ✅ Days names
const dayNamesEn = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const dayNamesUr = ["اتوار", "سوموار", "منگل", "بدھ", "جمعرات", "جمعہ", "ہفتہ"];

// ✅ Helper: Count summary
const getSummary = (days, staffId) => {
  const duties = days[staffId] || {};
  const counts = {};
  Object.values(duties).forEach((d) => {
    if (!d) return;
    counts[d] = (counts[d] || 0) + 1;
  });
  return counts;
};

// ✅ PDF Generator
const generatePDFBlob = async ({
  language,
  month,
  days,
  staff,
  numDays,
  names,
  viewMode,
}) => {
  const isUrdu = language === "ur";
  const hospitalName = isUrdu
    ? "راولپنڈی انسٹی ٹیوٹ آف کارڈیالوجی"
    : "Rawalpindi Institute of Cardiology";
  const subAddress = isUrdu ? "راول روڈ، راولپنڈی" : "Rawal Road, Rawalpindi";

  const title =
    viewMode === "individual" && staff.length === 1
      ? (isUrdu ? "ڈیوٹی روسٹر - " : "Duty Roster - ") + staff[0].name
      : isUrdu
      ? "ڈیوٹی روسٹر"
      : "Duty Roster";

  const leftLogoUrl = "../../assets/img/logo/new-logo.png";
  const rightLogoUrl = "../../assets/img/logo/punjab-logo.png";
  const currentYear = new Date().getFullYear();

  // Headers with day names + Sundays highlight
  const headers = Array.from({ length: numDays }, (_, i) => {
    const dayNum = i + 1;
    const date = new Date(`${month} ${dayNum}, ${currentYear}`);
    const dayName = isUrdu ? dayNamesUr[date.getDay()] : dayNamesEn[date.getDay()];
    const isSunday = date.getDay() === 0;

    return `<th style="padding:6px; border:1px solid #ccc; ${isSunday ? "background:#afb6c1; color:#fff; font-weight:700;" : "background:#eaf1ff; color:#333;"}">${dayNum}<br/><span style="font-size:8px; color:#555;">${dayName}</span></th>`;
  }).join("");

  // Rows
  const rowsHtml = staff
    .map((person) => {
      const rowCells = Array.from({ length: numDays }, (_, i) => {
      const dayNum = i + 1;
      const date = new Date(`${month} ${dayNum}, ${currentYear}`);
      const isSunday = date.getDay() === 0;

      let value = days[person.id]?.[dayNum] || "";
      if (isUrdu && dutyMapUrdu[value]) value = dutyMapUrdu[value];

      return `<td style="padding:6px; border:1px solid #ccc; ${
        isSunday ? "background:#afb6c1; color:#222; font-weight:600;" : ""
      }">${value}</td>`;
    }).join("");

      return `<tr><td style="padding:6px; border:1px solid #ccc; font-weight:600;">${person.name}</td>${rowCells}</tr>`;
    })
    .join("");

  // ✅ Summary Section
  let summaryHtml = "";
  if (staff.length > 0) {
  summaryHtml = `
    <h4 style="margin-top:20px;">${isUrdu ? "ماہانہ خلاصہ" : "Monthly Summary"}</h4>
    <table style="width:100%; border-collapse:collapse; font-size:10px; text-align:center;">
      <thead>
        <tr>
          <th style="border:1px solid #5aeb5aff; padding:4px;">${isUrdu ? "عملہ" : "Staff"}</th>
          <th style="border:1px solid #5ad5ebff; padding:4px;">M</th>
          <th style="border:1px solid #5ad5ebff; padding:4px;">E</th>
          <th style="border:1px solid #5ad5ebff; padding:4px;">N</th>
          <th style="border:1px solid #5ad5ebff; padding:4px;">L</th>
          <th style="border:1px solid #5ad5ebff; padding:4px;">D/O</th>
          <th style="border:1px solid #5ad5ebff; padding:4px;">P</th>
          <th style="border:1px solid #5ad5ebff; padding:4px;">A</th>
        </tr>
      </thead>
      <tbody>
        ${staff
          .map((p) => {
            const summary = getSummary(days, p.id);
            return `<tr>
              <td style="border:1px solid #ccc; padding:4px;">${p.name}</td>
              <td style="border:1px solid #ccc; padding:4px;">${summary.M || 0}</td>
              <td style="border:1px solid #ccc; padding:4px;">${summary.E || 0}</td>
              <td style="border:1px solid #ccc; padding:4px;">${summary.N || 0}</td>
              <td style="border:1px solid #ccc; padding:4px;">${summary.L || 0}</td>
              <td style="border:1px solid #ccc; padding:4px;">${summary["D/O"] || 0}</td>
              <td style="border:1px solid #ccc; padding:4px;">${summary.P || 0}</td>
              <td style="border:1px solid #ccc; padding:4px;">${summary.A || 0}</td>
            </tr>`;
          })
          .join("")}
      </tbody>
    </table>`;
}
 else {
    summaryHtml = `
      <h4 style="margin-top:20px;">${isUrdu ? "ماہانہ خلاصہ" : "Monthly Summary"}</h4>
      <table style="width:100%; border-collapse:collapse; font-size:10px; text-align:center;">
        <thead>
          <tr>
            <th style="border:1px solid #5aeb5aff; padding:4px;">${isUrdu ? "عملہ" : "Staff"}</th>
            <th style="border:1px solid #5ad5ebff; padding:4px;">M</th>
            <th style="border:1px solid #5ad5ebff; padding:4px;">E</th>
            <th style="border:1px solid #5ad5ebff; padding:4px;">N</th>
            <th style="border:1px solid #5ad5ebff; padding:4px;">L</th>
            <th style="border:1px solid #5ad5ebff; padding:4px;">D/O</th>
            <th style="border:1px solid #5ad5ebff; padding:4px;">P</th>
            <th style="border:1px solid #5ad5ebff; padding:4px;">A</th>
          </tr>
        </thead>
        <tbody>
          ${staff
            .map((p) => {
              const summary = getSummary(days, p.id);
              return `<tr>
                <td style="border:1px solid #ccc; padding:4px;">${p.name}</td>
                <td style="border:1px solid #ccc; padding:4px;">${summary.M || 0}</td>
                <td style="border:1px solid #ccc; padding:4px;">${summary.E || 0}</td>
                <td style="border:1px solid #ccc; padding:4px;">${summary.N || 0}</td>
                <td style="border:1px solid #ccc; padding:4px;">${summary.L || 0}</td>
                <td style="border:1px solid #ccc; padding:4px;">${summary["D/O"] || 0}</td>
                <td style="border:1px solid #ccc; padding:4px;">${summary.P || 0}</td>
                <td style="border:1px solid #ccc; padding:4px;">${summary.A || 0}</td>
              </tr>`;
            })
            .join("")}
        </tbody>
      </table>`;
  }

  const content = `
    <div style="font-family:${isUrdu ? "'Noto Nastaliq Urdu'" : "'Segoe UI', sans-serif"}; direction:${isUrdu ? "rtl" : "ltr"}; padding:20px; font-size:12px; color:#2c3e50;">
      <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:20px;">
        <div style="width:25%;"><img src="${leftLogoUrl}" style="height:60px;" /></div>
        <div style="text-align:center; width:60%;">
          <h2 style="margin:0; font-weight:700;">${hospitalName}</h2>
          <p style="margin:2px 0; font-size:13px; color:#555;">${subAddress}</p>
          <h4 style="margin:6px 0; color:#444;">${title} – ${month}</h4>
        </div>
        <div style="width:25%; text-align:${isUrdu ? "left" : "right"};"><img src="${rightLogoUrl}" style="height:60px;" /></div>
      </div>
      <table style="width:100%; border-collapse:collapse; text-align:center; font-size:9px;">
        <thead><tr><th style="padding:6px; border:1px solid #ccc; background:#0052D4; color:#fff;">${isUrdu ? "عملے کا نام" : "Staff"}</th>${headers}</tr></thead>
        <tbody>${rowsHtml}</tbody>
      </table>
      ${summaryHtml}
      <p style="text-align:center; margin-top:20px; font-size:10px; color:#888;">© ${currentYear} ${hospitalName}. ${isUrdu ? "جملہ حقوق محفوظ ہیں۔" : "All rights reserved."}</p>
    </div>`;

  return await html2pdf()
    .from(content)
    .set({
      margin: 0.3,
      filename: `Roster_${month}_${language}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "a4", orientation: "landscape" },
    })
    .output("blob");
};

// ✅ Main Component
export default function DutyRoster() {
  const [allStaff, setAllStaff] = useState([]);
  const [staffList, setStaffList] = useState([]);
  const [days, setDays] = useState({});
  const [names, setNames] = useState({});
  const [month, setMonth] = useState("");
  const [numDays, setNumDays] = useState(0);
  const [viewMode, setViewMode] = useState("individual");
  const [selectedStaff, setSelectedStaff] = useState([]);
  const [language, setLanguage] = useState("en");

  useEffect(() => {
    axios.get("https://ricgop.online/backend/staff/getStaff.php")
      .then((res) => setAllStaff(res.data))
      .catch(console.error);
  }, []);

  const fetchRoster = (m) => {
    axios.get(`https://ricgop.online/backend/staff/getData.php?month=${encodeURIComponent(m)}`)
      .then((res) => {
        if (res.data.success) {
          setDays(res.data.days);
          setNames(res.data.names);
          setNumDays(res.data.numDays);
          const filtered = allStaff.filter((st) => res.data.names[st.id]);
          setStaffList(filtered);
        } else {
          setDays({});
          setNames({});
          setNumDays(0);
          setStaffList([]);
        }
        setSelectedStaff([]);
      })
      .catch(console.error);
  };

  const monthOptions = Array.from({ length: 12 }, (_, i) => {
    const d = new Date();
    d.setMonth(d.getMonth() + i);
    const label = d.toLocaleString("default", { month: "long", year: "numeric" });
    return { label, value: label };
  });

  // ✅ Export PDF
  const exportPDF = async () => {
    const staff =
      viewMode === "individual" && selectedStaff.length > 0
        ? selectedStaff.map((s) => ({ id: s.value, name: names[s.value] }))
        : Object.entries(names).map(([id, name]) => ({ id, name }));

    const blob = await generatePDFBlob({ language, month, days, staff, numDays, names, viewMode });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Roster_${month}_${language}.pdf`;
    a.click();
    URL.revokeObjectURL(url);
  };

// ✅ Unified Frontend Summary with Urdu Support
const renderSummary = () => {
  if (!month) return null;

  // 🟡 Prevent showing anything if in individual mode and no staff selected
  if (viewMode === "individual" && selectedStaff.length === 0) {
    return (
      <div className="alert alert-secondary mt-3">
        <small>👆 Please select staff to view individual duty roster.</small>
      </div>
    );
  }

  const isUrdu = language === "ur";
  const headerLabels = isUrdu
    ? { Staff: "عملہ", M: "صبح", E: "دوپہر", N: "رات", L: "چھٹی", "D/O": "چھٹی", P: "حاضر", A: "غیر حاضر" }
    : { Staff: "Staff", M: "M", E: "E", N: "N", L: "L", "D/O": "D/O", P: "P", A: "A" };

  // ✅ Determine which staff to show
  const displayStaff =
    viewMode === "individual"
      ? selectedStaff.map((s) => ({ id: s.value, name: s.label }))
      : Object.entries(names).map(([id, name]) => ({ id, name }));

  return (
    <div className="mt-3" dir={isUrdu ? "rtl" : "ltr"}>
      <h6>
        📊 {viewMode === "individual" ? (isUrdu ? "انفرادی ڈیوٹی" : "Individual Duty View") : (isUrdu ? "ٹیم خلاصہ" : "Team Summary")} – {month}
      </h6>
      <table className="table-roster">
        <thead>
          <tr>
            <th>{headerLabels.Staff}</th>
            {Array.from({ length: numDays }).map((_, i) => {
              const date = new Date(`${month} ${i + 1}, ${new Date().getFullYear()}`);
              const isSunday = date.getDay() === 0;
              return (
                <th key={i} className={isSunday ? "sunday" : ""}>
                  {i + 1}
                  <br />
                  {isUrdu ? dayNamesUr[date.getDay()] : dayNamesEn[date.getDay()]}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {displayStaff.map(({ id, name }) => (
            <tr key={id}>
              <td>{name}</td>
              {Array.from({ length: numDays }).map((_, i) => {
                const date = new Date(`${month} ${i + 1}, ${new Date().getFullYear()}`);
                const isSunday = date.getDay() === 0;
                return (
                  <td key={i} className={isSunday ? "sunday" : ""}>
                    {days[id]?.[i + 1] || ""}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>

      {/* ✅ Monthly Summary Table (for both modes, with Urdu labels) */}
     <div className="mt-8">
  <h6
    className={`text-lg font-semibold mb-3 mt-3 text-center ${
      isUrdu ? "font-[Noto Nastaliq Urdu] text-right" : ""
    }`}
  >
    {isUrdu ? "ماہانہ خلاصہ" : "Monthly Summary"}
  </h6>
    <div className="overflow-x-auto shadow-md rounded-2xl border border-gray-200 bg-white"></div>
       <table className="min-w-full text-center text-sm border-collapse">
      <thead className="bg-gray-100 text-gray-700">
        <tr>
          <th className="py-2 px-3 border-b">{headerLabels.Staff}</th>
          <th className="py-2 px-3 border-b">{headerLabels.M}</th>
          <th className="py-2 px-3 border-b">{headerLabels.E}</th>
          <th className="py-2 px-3 border-b">{headerLabels.N}</th>
          <th className="py-2 px-3 border-b">{headerLabels.L}</th>
          <th className="py-2 px-3 border-b">{headerLabels["D/O"]}</th>
          <th className="py-2 px-3 border-b">{headerLabels.P}</th>
          <th className="py-2 px-3 border-b">{headerLabels.A}</th>
        </tr>
      </thead>
      <tbody>
        {displayStaff.map(({ id, name }) => {
          const summary = getSummary(days, id);
          return (
            <tr
              key={id}
              className="hover:bg-gray-50 transition-colors duration-150"
            >
              <td className="py-2 px-3 border-b font-medium text-gray-800">
                {name}
              </td>
              <td className="py-2 px-3 border-b">{summary.M || 0}</td>
              <td className="py-2 px-3 border-b">{summary.E || 0}</td>
              <td className="py-2 px-3 border-b">{summary.N || 0}</td>
              <td className="py-2 px-3 border-b">{summary.L || 0}</td>
              <td className="py-2 px-3 border-b">{summary["D/O"] || 0}</td>
              <td className="py-2 px-3 border-b text-green-700 font-semibold">
                {summary.P || 0}
              </td>
              <td className="py-2 px-3 border-b text-red-600 font-semibold">
                {summary.A || 0}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
    </div>
    </div>
  );
};



  return (
    <div className="container py-4">
      <h2 className="mb-4 fw-bold text-primary">📅 Duty Roster</h2>
      <div className="row g-3 mb-4">
        <div className="col-md-3">
          <label>📅 Month</label>
          <select
            className="form-select"
            value={month}
            onChange={(e) => {
              setMonth(e.target.value);
              if (e.target.value) fetchRoster(e.target.value);
              else {
                setStaffList([]);
                setDays({});
                setNames({});
                setNumDays(0);
                setSelectedStaff([]);
              }
            }}
          >
            <option value="">-- Select Month --</option>
            {monthOptions.map((m, i) => (
              <option key={i} value={m.value}>{m.label}</option>
            ))}
          </select>
        </div>
        <div className="col-md-3">
          <label>👁️ View</label>
          <select className="form-select" value={viewMode} onChange={(e) => setViewMode(e.target.value)}>
            <option value="individual">Individual</option>
            <option value="team">Team</option>
          </select>
        </div>
        <div className="col-md-3">
          <label>🌐 Language</label>
          <select className="form-select" value={language} onChange={(e) => setLanguage(e.target.value)}>
            <option value="en">English</option>
            <option value="ur">اردو</option>
          </select>
        </div>
        <div className="col-md-3">
          <label>👨‍⚕️ Staff</label>
          <Select
          options={staffList.map((st) => ({ value: st.id, label: `${st.name} – ${st.role}` }))}
          value={selectedStaff}
          onChange={setSelectedStaff}
          isDisabled={viewMode === "team"}
          isMulti
          menuPortalTarget={document.body}          // ✅ Render menu on top level
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }), // ✅ Keep it above everything
          }}
        />

        </div>
      </div>
      <button className="btn btn-danger mb-3" onClick={exportPDF} disabled={!month}>📄 Export PDF</button>
      {renderSummary()}

      {/* Styles */}
      <style>{`
        .calendar {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(40px, 1fr));
          border: 1px solid #ccc;
        }
        .calendar-header, .calendar-row {
          display: contents;
        }
        .calendar-cell {
          border: 1px solid #ccc;
          padding: 6px;
          text-align: center;
          font-size: 0.85rem;
        }
        .staff-name {
          font-weight: bold;
          background: #f3f6ff;
        }
        .table-roster {
          width: 100%;
          border-collapse: collapse;
          font-size: 0.9rem;
          text-align: center;
        }
        .table-roster th {
          background-color: #0052D4;
          color: white;
          padding: 8px;
          position: sticky;
          top: 0;
          z-index: 1;
        }
        .table-roster td {
          padding: 6px;
          border: 1px solid #ccc;
        }
        .table-roster tbody tr:nth-child(even) {
          background-color: #f3f6ff;
        }
        .table-roster tbody tr:hover {
          background-color: #dbe4ff;
        }
        .sunday {
        background-color: #b9b6b6ff; /* light red background */
        color: rgba(12, 1, 1, 1); /* darker red text for emphasis */
        font-weight: 600;
      }
      `}</style>
    </div>
  );
}
